import * as _ from 'lodash-es'

const install = (app) => {
  app.config.globalProperties.$_ = _
}

export { install as default }
